import React, { useState } from "react"
import { Button, Spinner, Stack } from "react-bootstrap";
import useUXStore from "../api/ux/store";
import { assign } from "../utils/functions";
import BaseControl from "./BaseControl";
import CStack from "./CStack";
import SwitchControl from "./SwitchControl"; 



type DataViewProps = {
    name?            : string
    label?           : string
    defaultData?     : any
    onApply?         : (newData:any) => Promise<any>
    onCreate?        : (newData:any) => Promise<any>
    onDelete?        : (data:any) => Promise<void>
    isnew?           : boolean
    readonly?        : boolean
    loading?          : boolean
    children         : (data:any,onChanged:(id:any,value:any)=>void,showEdit:boolean) => JSX.Element
}

const EditorControl:React.FC<DataViewProps> = (
    {name="name", label="label", readonly, isnew=false,defaultData={}, onApply=(newData) =>{}, onCreate, loading = false, onDelete=null, children}) => {
    const [data,setData] = useState(defaultData)
    // true if data is not yet saved to db
    const [newly,setNewly] = useState(isnew)
    // true if modified
    const [dirty,setDirty] = useState(newly)
    // true if currently editing
    const [edit,setEdit] = useState(newly)
    const { refreshDialog, popPage, addToast } = useUXStore( state => state)

    const onChangedValue = (id:any,value:any) => {
        const newData = {...data}
        assign(newData,id,value)
        setData(newData)
        setDirty(true)
        //console.log("NEW",newData)
    }
    const onToggleEdit = (checked:boolean) => {
        if (!checked) {
            setDirty(false)
            setData(defaultData)
        }
        setEdit(checked)
    }
    const onCancelEdit = (e:any) => {
        setEdit(false)
        setDirty(false)
        setData(defaultData)
    }
    const onApplyChanges = async (e:any) => {
        setDirty(false)
        setEdit(false)
        await onApply(data)
        //setData(cdata)
    }
    const onCreateData = async (e:any) => {
        let newId = await onCreate!(data)
        // failed to create data
        if (newId === "") {
            popPage()
            return
        }
        setData({...data, id:newId})
        setDirty(false)
        setEdit(false)
        setNewly(false)
    }

    const onCancelCreateData = (e:any) => {
        popPage()
    }
    const onDeleteData = (e:any) => {
        refreshDialog({
            id: "deleteData",
            title: "Delete " + name,
            visible: true,
            content: `Are you sure you want to delete ${label}?`,
            onConfirm: () => {
                onDelete!(data).then( () => {
                    popPage()
                    addToast("", name + " was deleted successfully.")
                })
                //console.log("Deleted")
                
            }
        }, true)
    }
    const showEdit = edit && !loading && !readonly
    return <CStack header="">
        {!newly && <SwitchControl text="Toggle edit" edit={!readonly} value={edit} onChanged={onToggleEdit}/>}
       
        {children(data, onChangedValue, showEdit)}

        {onDelete !== null && !newly && edit && <BaseControl text={"Remove " + label}>
            <Button size="sm" onClick={onDeleteData} variant="outline-danger">Delete</Button>
        </BaseControl>}
        {!newly && edit && <BaseControl text="Apply changes?">
            <Stack direction="horizontal" gap={2}>
                <Button size="sm" onClick={onCancelEdit} variant="outline-secondary">Cancel</Button>
                <Button size="sm" disabled={!dirty || loading} onClick={onApplyChanges} variant="primary">
                    {!loading ? "Apply": <Stack direction="horizontal" gap={1}><Spinner size="sm"/>Applying</Stack>}
                </Button>
            </Stack>
        </BaseControl>}
        {newly && <BaseControl text={"Create " + label}>
            <Stack direction="horizontal" gap={2}>
                <Button size="sm" disabled={loading} onClick={onCancelCreateData} variant="outline-secondary">Cancel</Button>
                <Button size="sm" disabled={loading} onClick={onCreateData} variant="primary">
                    {!loading ? "Create": <Stack direction="horizontal" gap={1}><Spinner size="sm"/>Creating</Stack>}
                </Button>
            </Stack>
        </BaseControl>}
    </CStack>
}

export default EditorControl

